import endDiscussionLogo from '../../assets/end-discussion-logo.png'
import Header from '../common/Header'
import './EndDiscussion.css';

const EndOfDiscussion = () => {
	return (
		<div className='end-of-discussion-page'>
			<Header/>
			<img 
				className="end-discussion-logo" 
				src={endDiscussionLogo} 
				alt="end discussion logo"
			/>
			<h1 className='end-of-discussion-title'>
				Session has ended
			</h1>
		</div>
	);
}
 
export default EndOfDiscussion;